export default "__VITE_ASSET__pZ5ek_EL__"